import { render, staticRenderFns } from "./SecOwnershipTaskItem.vue?vue&type=template&id=42bdfc7a&scoped=true&"
import script from "./SecOwnershipTaskItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./SecOwnershipTaskItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SecOwnershipTaskItem.vue?vue&type=style&index=0&id=42bdfc7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bdfc7a",
  null
  
)

export default component.exports